import { render, staticRenderFns } from "./Utterance.vue?vue&type=template&id=1cc4de25&scoped=true&"
import script from "./Utterance.vue?vue&type=script&lang=ts&"
export * from "./Utterance.vue?vue&type=script&lang=ts&"
import style0 from "./Utterance.vue?vue&type=style&index=0&id=1cc4de25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4de25",
  null
  
)

export default component.exports